// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { TimeBaseEntity } from '../time-base-entity';
import { SetRateSchedule } from './set-rate-schedule';

/// <code-import> Place custom imports between <code-import> tags
import { UserType } from '..';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class UserTypeRate extends TimeBaseEntity  {

  /// <code> Place custom code between <code> tags
  userType: UserType;
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  createdAt!: Date;
  createdBy?: string;
  from?: Date;
  isDefault!: boolean;
  practiceId!: number;
  rateScheduleId?: number;
  timeRate!: number;
  ts?: any;
  updatedAt!: Date;
  updatedBy?: string;
  userTypeId!: number;
  rateSchedule!: SetRateSchedule;
}

